
import Vue from 'vue';
import { Icon } from '@descomplica/vue-components';
import { ListModel, ReplyModel, QuestionModel } from '@descomplica/dex-models';
import StatusCircle from '../StatusCircle.vue';
import CardCaption from './CardCaption.vue';
import Constants from '@/settings/ui';
import ProgressBar from '../progress/ProgressBar.vue';

export default Vue.extend({
  components: {
    Icon,
    CardCaption,
    StatusCircle,
    ProgressBar,
  },
  props: {
    list: {
      type: ListModel,
      required: true,
    },
    isLocked: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      white: Constants.colorPalette.white,
    };
  },
  computed: {
    title(): String {
      return this.list.name;
    },
    isComplete(): boolean {
      return this.currentItemsCount === this.maxItemsCount;
    },
    questions(): QuestionModel[] {
      return this.list.questions;
    },
    correctCounter(): number {
      let correct = 0;
      this.questions.forEach((question: QuestionModel) => {
        if (this.isQuestionCorrect(question)) correct += 1;
      });

      return correct;
    },
    incorrectCounter(): Number {
      let incorrect = 0;
      this.questions.forEach((question: QuestionModel) => {
        if (this.isQuestionCorrect(question) === false) incorrect += 1;
      });

      return incorrect;
    },
    maxItemsCount(): number {
      return this.questions.length;
    },
    currentItemsCount(): Number {
      let currentItemsCount = 0;
      this.questions.forEach((question: QuestionModel) => {
        if (this.questionHasReply(question)) currentItemsCount += 1;
      });
      return currentItemsCount;
    },
    correctPercentage(): Number {
      return (100 * this.correctCounter) / this.maxItemsCount || 0;
    },
  },
  methods: {
    questionHasReply(question: QuestionModel): Boolean {
      const indexOf = question.replies.findIndex(
        (reply: ReplyModel) => reply.questionId === question.id,
      );
      return indexOf !== -1;
    },
    getUserQuestionReply(question: QuestionModel): ReplyModel | null {
      const replies = question.replies.filter(
        (reply: ReplyModel) => reply.questionId === question.id,
      );

      if (!replies || !replies.length) {
        return null;
      }

      const mostRecentReply = replies.reduce((reply1: ReplyModel, reply2: ReplyModel) => {
        const date1 = new Date(reply1.createdAt as string);
        const date2 = new Date(reply2.createdAt as string);
        return date1.getTime() > date2.getTime() ? reply1 : reply2;
      });

      return mostRecentReply || null;
    },
    isQuestionCorrect(question: QuestionModel): Boolean | void {
      const reply = this.getUserQuestionReply(question);
      if (!reply || !reply.id || !reply.questionId || !reply.assertionId) return undefined;

      return !!reply && !!reply.isCorrect();
    },
  },
});
